import { type NodeSn, isDeviceType } from '@ipfabric/utils';
import { getPrimitiveOrd } from '@ipfabric/utils/fp/ordering';
import { prop } from '@ipfabric/utils/fp/prop';
import type { GraphState } from 'components/Graph/GraphState';
import { selectNodesStableData } from 'components/Graph/model/selectors/selectNodesStableData';
import { array, record } from 'fp-ts';
import { flow } from 'fp-ts/lib/function';
import { createSelector } from 'reselect';
import { makeMemoizeObject } from 'utils/memoize/makeMemoizeObject';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectDeviceSns: (s: GraphState) => NodeSn[] =
  createScopedSelector(() => {
    const memoizeObject = makeMemoizeObject<NodeSn[]>();

    return createSelector(
      selectNodesStableData,
      flow(
        record.filter(flow(prop('type'), isDeviceType)),
        Object.values,
        array.map(prop('sn')),
        array.sort(getPrimitiveOrd()),
        memoizeObject,
      ),
    );
  });
